import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { withRouter } from "react-router-dom";
import { ProfileSection } from "../../context/ProfileContext";
import {
  getFolio,
  getSupportTypeList,
  getSupportMine,
  logoutApi,
} from "../../api";
import { setFolio, setSupportTypeList, setSupportMine } from "../../redux";
import { SettingFullScreenButton } from "./SettingFullScreenButton";
import { useTranslation } from "react-i18next";
const SettingComp = (props) => {
  const { t } = useTranslation();
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const howToUseClicked = () => {
    ProfileShowHideFunc("howUse");
    const data = new FormData();
    data.append("folio", "نحوه-استفاده");
    getFolio(data, token)
      .then((res) => {
        dispatch(setFolio(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
        const isFullScreen = localStorage.getItem("isFullScreen") === "true";
        const checkbox = document.getElementById("myCheck");
        if (checkbox) {
          checkbox.checked = isFullScreen;
        }
      });
    const isFullScreen = Cookies.get("isFullScreen") === "true";
    const checkbox = document.getElementById("myCheck");
    if (checkbox) {
      checkbox.checked = isFullScreen;
    }
  };

  //   const visibleChanged = () => {
  //     var MyBox;
  //     MyBox = document.getElementById("MyBox");
  //     if (MyBox.requestFullscreen) {
  //       MyBox.requestFullscreen();
  //     } else if (MyBox.webkitRequestFullscreen) {
  //       // Safari , Chrome , Opera
  //       MyBox.webkitRequestFullscreen();
  //     } else if (MyBox.mozRequestFullscreen) {
  //       // FireFox
  //       MyBox.mozRequestFullscreen();
  //     } else if (MyBox.msRequestFullscreen) {
  //       // Internet Explorer 11
  //       MyBox.msRequestFullscreen();
  //     }
  //   };

  const supportClicked = () => {
    ProfileShowHideFunc("contactUs");
    getSupportTypeList(token)
      .then((res) => {
        dispatch(setSupportTypeList(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
        const isFullScreen = localStorage.getItem("isFullScreen") === "true";
        const checkbox = document.getElementById("myCheck");
        if (checkbox) {
          checkbox.checked = isFullScreen;
        }
      });
    const isFullScreen = Cookies.get("isFullScreen") === "true";
    const checkbox = document.getElementById("myCheck");
    if (checkbox) {
      checkbox.checked = isFullScreen;
    }

    getSupportMine(token)
      .then((res) => {
        dispatch(setSupportMine(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  const logOut = () => {
    logoutApi(token)
      .then(() => {
        Cookies.remove("token");
        props.history.push("/");
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };
  //.button2 {background-color: #008CBA;}
  return (
    <div id="MyBox">
      <p className="text-center my-4">{t("تنظیمات")}</p>
      <div style={{ minHeight: "60vh" }}>
        {/* <div className="editInputs w-100 cursor p-3 mb-1" onClick={() => ProfileShowHideFunc('')}>
                    <p className="m-0 text-right fn12">تمام صفحه <i className="switchDevice">

                        
                        </i></p>
                </div> */}

        <div className="w-100 inputs px-3 text-right mb-3 d-flex align-items-center justify-content-between">
          <p className="fn m-0">{t("نمایش تمام صفحه")}</p>
          <SettingFullScreenButton />
          {/* <label className="switchDevice">
            <input
              type="checkbox"
              id="myCheck"
              //   defaultChecked={visible === "0" ? true : false}
              onChange={visibleChanged}
            />
            <span className="switchSliderDevice round"></span>
          </label> */}
        </div>

        <div
          className="editInputs w-100 cursor p-3 mb-1"
          onClick={() => ProfileShowHideFunc("changePassPage")}
        >
          <p className="m-0 text-right fn12">{t("فراموشی رمز عبور")}</p>
        </div>
        <div
          className="editInputs w-100 cursor p-3 mb-1"
          onClick={() => ProfileShowHideFunc("privacy")}
        >
          <p className="m-0 text-right fn12">{t("حریم خصوصی")}</p>
        </div>
        <div
          className="editInputs w-100 cursor p-3 mb-1"
          onClick={howToUseClicked}
        >
          <p className="m-0 text-right fn12">{t("نحوه استفاده")}</p>
        </div>
        <div
          className="editInputs w-100 cursor p-3 mb-1"
          onClick={supportClicked}
        >
          <p className="m-0 text-right fn12">{t("پشتیبانی")}</p>
        </div>
        <div className="editInputs w-100 cursor p-3 mb-1">
          <p className="m-0 text-right fn12">{t("شرایط و قوانین")}</p>
        </div>
        <div className="editInputs w-100 cursor p-3 mb-1" onClick={logOut}>
          <p className="m-0 text-right fn12">{t("خروج")}</p>
        </div>
      </div>
      <div className="d-flex flex-wrap justify-content-center mt-4">
        <div
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={() => ProfileShowHideFunc("firstPage")}
        >
          <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
          <small className="fn12 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
    </div>
  );
};

const Setting = withRouter(SettingComp);

export { Setting };
